<template>
  <div>
    <appHeader></appHeader>
    <div class="container-fluid customer-orders">
      <div class="row">
        <div class="col-md-3 col-sm-12 pr-0 dark-bg">
          <appAdminSidebar></appAdminSidebar>
        </div>
        <transition appear name="fade">
          <div class="col-md-9 p-4">
            <h4>Customer Orders</h4>
            <customerOrdersForm class="mt-4"></customerOrdersForm>
          </div>
        </transition>
      </div>
    </div>
  </div>
</template>

<script>
import Header from "@/components/Header.vue";
import divvyAdminSidebar from "@/views/divvyadmin/divvyAdminSidebar.vue";
import CustomerOrdersForm from "./CustomerOrdersForm.vue";
export default {
  name: "CustomerOrders",
  components: {
    appHeader: Header,
    appAdminSidebar: divvyAdminSidebar,
    customerOrdersForm: CustomerOrdersForm,
  },
  methods: {
    setActiveMenuItem: function () {
      this.$store.dispatch("divvyAdminSidebar/setActive", {
        activeMenuItem: this.activeMenuItem
          ? this.activeMenuItem
          : "customerOrders",
        activeMenu: this.activeMenu ? this.activeMenu : "crm-tools",
      });
    },
  },

  created() {
    this.setActiveMenuItem();
  },
};
</script>
<style lang="scss" scoped>
.customer-orders {
  //   margin: 70px 0 0 0;
  min-height: 100%;
  margin: -14px 0 0 0;
  .badge {
    font-size: 0.8rem;
    padding: 6px 0px;
    border-radius: $border-radius-sm;
  }
}
.marginAll {
  margin: 10px;
}

html,
body {
  height: 100%;
}
</style>
